import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
    }

    body {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', monospace,
        sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        background-color: #f5f5f5;
        -webkit-touch-callout: none;
        position: relative;
        width: 100%;
        height: 100%;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
    }

    #root {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }

    button {
        cursor: pointer;
        border: none;
        background: none;
        font-family: inherit;
    }

    a {
        text-decoration: none;
        color: inherit;
    }

    /* Fix for coloring page */
    .coloring-page {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
        background-color: rgba(232, 223, 214, 0.4);
    }

    // @media screen and (orientation: landscape) and (max-width: 768px) {
    //   body {
    //     transform: rotate(-90deg);
    //     transform-origin: left top;
    //     width: 100vh;
    //     height: 100vw;
    //     overflow-x: hidden;
    //     position: fixed;
    //     top: 100%;
    //     left: 0;
    //   }
    // }
`;

export default GlobalStyle; 